"use strict";
class bb_omekaWidgetItemRow {
  constructor(element, collection) {
    this.htmlElement = element;
    this.usedCollection = collection;
    this.itemThumbnailElements = this.htmlElement.querySelectorAll("[data-target=thumbnail]");
    this.itemTitleElements = this.htmlElement.querySelectorAll("[data-target=title]");
    this.itemLinkElements = this.htmlElement.querySelectorAll(".bb-omekaWidgetItemRowLink");
    this.seeAllFromCategoryButton = this.htmlElement.querySelector(".bb-omekaWidgetItemRow-button-box a");

    // Prepare Request Header
    let httpHeader = {};
    let requestParams = new URLSearchParams();
    requestParams.set("item_set_id", collection);
    requestParams.set("per_page", 30);
    requestParams.set("resource_class_id[]", 26);
    requestParams.set("sort_by", "created");
    requestParams.set("sort_order", "desc");
    let request = new Request(api_itemURL + requestParams.toString(), {
      method: "GET",
      headers: new Headers(httpHeader),
    });

    let currentUrl = new URL(window.location);
    let currentParams = new URLSearchParams(currentUrl.search);

    // Render Items
    omekaAPI.getItemOnly(request).then(
      function (resultRaw) {
        let result = [];
        let resultTotal = resultRaw.length;
        let tryResult = "";

        function pickRandomItem(i) {
          if (!result[0]) {
            result[i] = resultRaw[Math.floor(Math.random() * resultTotal)];
            return true;
          }
          tryResult = resultRaw[Math.floor(Math.random() * resultTotal)];
          if (!result.some((element) => element === tryResult)) {
            result[i] = tryResult;
            return true;
          }
          return false;
        }

        for (let i = 0; i < 4; ) {
          if (pickRandomItem(i)) {
            i++;
          }
        }

        result.forEach((element, index) => {
          if (currentParams.has("lang")) {
            let langParam = currentParams.get("lang");
            this.itemLinkElements[index].href = `/item/?id=${element["o:id"]}&lang=${langParam}`;
          } else {
            this.itemLinkElements[index].href = `/item/?id=${element["o:id"]}`;
          }

          this.itemThumbnailElements[index].src = element.thumbnail_display_urls.square;
          this.seeAllFromCategoryButton.href = `/archiv/?item_set_id[0]=${collection}`;
          this.itemTitleElements[index].textContent = element["dcterms:title"][0]["@value"];
        });
      }.bind(this)
    );
  }
}

function checkForomekaWidgetItemRow() {
  let allWidgets = document.querySelectorAll("[bb_omekaWidget=item-row]");
  if (allWidgets.length > 0) {
    allWidgets.forEach((element, index) => {
      let usedCollection = allWidgets[index].attributes.bb_widgetCollection.value;
      new bb_omekaWidgetItemRow(allWidgets[index], usedCollection);
    });
  }
}

document.addEventListener("DOMContentLoaded", checkForomekaWidgetItemRow);
